<template>
  <div v-if="visible" class="p-4">
    <h4 class="mb-3">Unterschrift</h4>
    <p class="text-muted mb-4">
      Bitte unterschreibe im Feld unten. Die Unterschrift wird der Quittung hinzugefügt.
    </p>

    <div class="signature-container">
      <canvas
        ref="signatureCanvas"
        class="signature-canvas border rounded bg-white"
        :class="{ 'signature-canvas--locked': isCanvasLocked }"
        :aria-disabled="isCanvasLocked ? 'true' : 'false'"
        width="600"
        height="300"
        @mousedown="startDrawing"
        @mousemove="draw"
        @mouseup="stopDrawing"
        @touchstart="startDrawing"
        @touchmove="draw"
        @touchend="stopDrawing"
      ></canvas>
    </div>

    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mt-3 gap-2">
      <div class="d-flex flex-wrap gap-2">
        <button type="button" class="btn btn-outline-secondary" @click="clearSignature">
          <font-awesome-icon icon="eraser" class="me-1" />
          Löschen
        </button>
        <button
          v-if="hasStoredSignature"
          type="button"
          class="btn btn-outline-primary"
          @click="handleApplyStoredSignature"
        >
          <font-awesome-icon icon="download" class="me-1" />
          Gespeicherte Unterschrift verwenden
        </button>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <label for="recipientEmail" class="form-label">Empfänger-E-Mail (optional)</label>
        <input
          type="email"
          class="form-control"
          id="recipientEmail"
          v-model="formData.recipientEmail"
          placeholder="empfaenger@beispiel.de"
          :class="{ 'is-invalid': errors.recipientEmail }"
          @input="onEmailInput"
          @blur="validateRecipientEmail"
        />
        <div class="invalid-feedback" v-if="errors.recipientEmail">
          {{ errors.recipientEmail }}
        </div>
        <div class="form-text">
          Eine Kopie wird an diese E-Mail-Adresse gesendet
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { ReceiptWizardSymbol } from '../../tokens'

const wizard = inject(ReceiptWizardSymbol)

if (!wizard) {
  throw new Error('StepSignature requires ReceiptWizard context')
}

const visible = computed(() => wizard.isCurrentStep('Unterschrift'))
const signatureCanvas = wizard.signatureCanvas
const startDrawing = wizard.startDrawing
const draw = wizard.draw
const stopDrawing = wizard.stopDrawing
const clearSignature = wizard.clearSignature
const hasSignature = wizard.hasSignature
const applyStoredSignature = wizard.applyStoredSignature
const hasStoredSignature = wizard.hasStoredSignature
const storedSignatureUpdatedAt = wizard.storedSignatureUpdatedAt
const usingStoredSignature = wizard.usingStoredSignature
const isCanvasLocked = computed(() => usingStoredSignature.value)
const formData = wizard.formData
const errors = wizard.errors
const validateRecipientEmail = wizard.validateRecipientEmail
const clearFieldError = wizard.clearFieldError

const storedSignatureInfo = computed(() => {
  if (!storedSignatureUpdatedAt?.value) {
    return ''
  }

  try {
    return new Intl.DateTimeFormat('de-DE', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(storedSignatureUpdatedAt.value))
  } catch (error) {
    return ''
  }
})

const handleApplyStoredSignature = () => {
  applyStoredSignature()
}

const onEmailInput = () => {
  clearFieldError('recipientEmail')
  validateRecipientEmail()
}
</script>

<style scoped>
.signature-canvas--locked {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.85;
}
</style>
